module.exports = __webpack_public_path__ + "img/reward-tickets.75c111bb.png";